<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hMI8pf/tc-custom/9781504093651.jpg?1728259219420" alt="This image is the cover for the book Murder on Tour, Francis Meadowes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder on Tour, Francis Meadowes
      </h1>
      <p class="bookDescription body article font2">
        <b>A novice detective joins a rock star’s entourage to follow a trail of sex, drugs, and suspicious deaths, in this brand-new murder mystery by the author of <i>Murder Your Darlings</i>.</b><br/><br/> Crime writer Francis Meadowes has just been offered his first paid detective gig—which means going on the road with gender-fluid rock star JonniK, tagging along as the musician’s entourage travels from Berlin to Brussels and beyond. Jonni’s manager is already worried by a guitar tech’s fatal overdose on a tour bus, but then the star himself is attacked on stage . . .<br/><br/> Another shock comes as Jonni’s lead guitarist is electrocuted by his own instrument in the middle of a gig—and Francis realises he is in a dangerous race against time to find out exactly what is going on . . .<br/><br/><b>Praise for the Francis Meadowes mysteries</b><br/><br/> “A rollicking read.” —<i>London Evening Standard</i><br/><br/> “Very engaging.” —<i>The Sydney Morning Herald</i><br/><br/> “Readers will have fun.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark McCrum
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44d2d0ce